import { useTranslation } from "react-i18next";
import QuickViewPanelWrapper from "../../../../components/quick-view-panel-wrapper/QuickViewPanelWrapper";
import { AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";
import { classNames } from "primereact/utils";
import { ChecklistResponse } from "../../../../models/endpoints/checklists-endpoint.model";

const ChecklistsQuickViewPanel = (props: {
	isLoading: boolean;
	isError: boolean;
	checkLists: ChecklistResponse[] | undefined;
	onClickAction: () => void;
}) => {
	const { t } = useTranslation("common");

	const isDataAvailable = props.checkLists && props.checkLists.length > 0;

	if (props.isLoading) {
		return (
			<QuickViewPanelWrapper
				title="PARTICIPANT.DASHBOARD.CHECKLISTS.QUICK_VIEW.PANEL_TITLE"
				onClickAction={props.onClickAction}
				isLoading={props.isLoading}
				isError={props.isError}
			>
				<p className="panel-no-data loading">
					<i className="pi pi-spin pi-spinner message-icon"></i>
					{t("PARTICIPANT.DASHBOARD.CHECKLISTS.MESSAGES.LOADING")}
				</p>
			</QuickViewPanelWrapper>
		);
	}

	if (props.isError) {
		return (
			<QuickViewPanelWrapper
				title="PARTICIPANT.DASHBOARD.CHECKLISTS.QUICK_VIEW.PANEL_TITLE"
				onClickAction={props.onClickAction}
				isLoading={props.isLoading}
				isError={props.isError}
			>
				<p className="panel-no-data has-error">
					{t("PARTICIPANT.DASHBOARD.CHECKLISTS.MESSAGES.ERROR")}
				</p>
			</QuickViewPanelWrapper>
		);
	}

	if (!isDataAvailable) {
		return (
			<QuickViewPanelWrapper
				title="PARTICIPANT.DASHBOARD.CHECKLISTS.QUICK_VIEW.PANEL_TITLE"
				onClickAction={props.onClickAction}
				isLoading={props.isLoading}
				isError={props.isError}
			>
				<p className="panel-no-data">
					{t("PARTICIPANT.DASHBOARD.CHECKLISTS.MESSAGES.NO_DATA")}
				</p>
			</QuickViewPanelWrapper>
		);
	}

	return (
		<QuickViewPanelWrapper
			title="PARTICIPANT.DASHBOARD.CHECKLISTS.QUICK_VIEW.PANEL_TITLE"
			onClickAction={props.onClickAction}
			isLoading={props.isLoading}
			isError={props.isError}
		>
			{isDataAvailable && <ChecklistList checklists={props.checkLists!} />}
		</QuickViewPanelWrapper>
	);
};

const ChecklistList = (props: { checklists: ChecklistResponse[] }) => {
	return (
		<div className="pt-dashboard__checklists-quick-view">
			<ul className="panel-list">
				{props.checklists.map((item, index) => (
					<li
						key={index}
						className="panel-list-item"
					>
						{item.applicable && <div className="text-bold text-black">{item.name}</div>}
						{item.applicable &&
							item.items
								?.filter((x) => x.applicable)
								.map((subItem, subIndex) => (
									<div
										key={subIndex}
										className="checklist-item"
									>
										<span className="item-value">{subItem.name}</span>
										{subItem.completed ? (
											<AiFillCheckCircle
												className={classNames(
													"pb-1 ms-1 checklists-quick-view__status-indicator true"
												)}
												fontSize={"22px"}
											/>
										) : (
											<AiFillCloseCircle
												className={classNames(
													"pb-1 ms-1 checklists-quick-view__status-indicator false"
												)}
												fontSize={"22px"}
											/>
										)}
									</div>
								))}
					</li>
				))}
			</ul>
		</div>
	);
};

export default ChecklistsQuickViewPanel;
